import {Navigate, Route, Routes} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';

import LoginPage from './features/auth/pages/LoginPage.tsx';
import PublicLayout from './layouts/PublicLayout';
import EditorLayout from './layouts/EditorLayout.js';

import HomePage from './features/home/pages/HomePage.tsx';
import PublicNewsPage from './features/news/pages/NewsPage.tsx';
import NewsDetailPage from './features/news/pages/NewsDetailPage.tsx';
import PublicCompetitionPage from './features/competitions/pages/PublicCompetitionPage.tsx';

import TeamPage from "./features/team/pages/TeamPage.tsx";
import SportNewsPage from "./features/news/pages/SportNewsPage.tsx";
import ProgramsPage from "./features/programs/pages/ProgramsPage.tsx";
import {Toaster} from "sonner";
import AdminLayout from "./layouts/AdminLayout.js";
import AdminUsersPage from "./features/users/pages/AdminUsersPage.tsx";
import AdminBannersPage from "./features/banners/pages/AdminBannersPage.tsx";
import AdminCategoriesPage from "./features/categories/pages/AdminCategoriesPage.tsx";
import ListenNewsPage from "./features/news/pages/ListenNewsPage.tsx";
import CategoriesSelectionPage from "./features/categories/pages/CategoriesSelectionPage.tsx";
import PodcastsPage from "./features/podcasts/pages/PodcastsPage.js";
import ThoughtsOfTheDay from "./features/podcasts/pages/ThoughtsOfTheDay.js";
import AdminNewsPage from "./features/news/pages/AdminNewsPage.js";
import AdminCompetitionsPage from "./features/competitions/pages/AdminCompetitionsPage.js";
import {RoleRoute} from "./RoleRoute.js";
import TermsAndConditionsPage from "./features/legal/pages/TermsAndConditions.js";
import AdminTagsPage from "./features/tags/pages/AdminTagsPage.js";
import OnAirNewsPage from "./features/news/pages/OnAirNewsPage.js";
import AdminProgramsPage from "./features/programs/pages/AdminProgramPage.js";
import AdminTeamPage from "./features/team/pages/AdminTeamPage.js";
import PrivacyPolicyPage from "./features/legal/pages/PrivacyPolicyPage.js";
import TodayNewsPage from "./features/news/pages/TodayNewsPage.js";
import ResearchNewsPage from "./features/news/pages/ResearchNewsPage.js";
import CheckoutStatusPage from "./features/checkout/CheckoutStatusPage.tsx";

export default function App() {
    return (
        <>
            <AuthProvider>
                <Routes>
                    {/* PUBLIC ROUTES */}
                    <Route element={<PublicLayout/>}>
                        <Route index element={<HomePage/>}/>
                        <Route path="nuus" element={<PublicNewsPage/>}/>
                        <Route path="nuus/:slug" element={<NewsDetailPage/>}/>
                        <Route path="nuus/luister" element={<ListenNewsPage/>}/>
                        <Route path="nuus/op-die-kantlyn" element={<SportNewsPage/>}/>
                        <Route path="nuus/op-die-lug" element={<OnAirNewsPage/>}/>
                        <Route path="nuus/die-dag-wat-was" element={<TodayNewsPage/>}/>
                        <Route path="nuus/ondersoek" element={<ResearchNewsPage/>}/>
                        <Route path="nuus/kategorieë" element={<CategoriesSelectionPage/>}/>
                        <Route path="kompetisies" element={<PublicCompetitionPage/>}/>
                        <Route path="op-die-lug/aanbieders" element={<TeamPage/>}/>
                        <Route path="op-die-lug/programme" element={<ProgramsPage addPadding={true}/>}/>
                        <Route path="potgooi/gesprekke" element={<PodcastsPage/>}/>
                        <Route path="potgooi/gedagte-vir-die-dag" element={<ThoughtsOfTheDay/>}/>
                        <Route path="kompetisies-ts-and-cs" element={<TermsAndConditionsPage/>}/>
                        <Route path="privacy-policy" element={<PrivacyPolicyPage/>}/>

                        <Route path="/checkout/status/:reference" element={<CheckoutStatusPage/>}/>
                    </Route>

                    {/* PROTECTED EDITOR ROUTES (ADMIN or EDITOR) */}
                    <Route
                        path="/editor"
                        element={
                            <RoleRoute allowed={['ADMIN', 'EDITOR']}>
                                <EditorLayout/>
                            </RoleRoute>
                        }
                    >
                        <Route path="news" element={<AdminNewsPage/>}/>
                        <Route path="categories" element={<AdminCategoriesPage/>}/>
                        <Route path="tags" element={<AdminTagsPage/>}/>
                        <Route path="banners" element={<AdminBannersPage/>}/>
                        <Route path="competitions" element={<AdminCompetitionsPage/>}/>
                        <Route path="programs" element={<AdminProgramsPage/>}/>
                        <Route path="team-members" element={<AdminTeamPage/>}/>
                    </Route>

                    {/* PROTECTED ADMIN ROUTES (ADMIN only) */}
                    <Route
                        path="/admin"
                        element={
                            <RoleRoute allowed={['ADMIN']}>
                                <AdminLayout/>
                            </RoleRoute>
                        }
                    >
                        <Route path="users" element={<AdminUsersPage/>}/>
                    </Route>

                    {/* AUTH */}
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
                <Toaster position="top-right" closeButton expand/>
            </AuthProvider>
        </>
    );
}
